module.exports = __webpack_public_path__ + "media/images/backgrounds/angle-top-right-1d6c63a72af55a95db6f22557b31ed44.svg";